<template>
  <c-row>
    <c-col col="6">
      <c-card>
        <loader v-show="loading" />
        <c-card-header>
          <strong>Add Paymenth Method</strong>
        </c-card-header>
        <c-card-body>
          <c-form>
            <div class="form-group">
              <label for="payment-method" class="col-form-label">Label</label>
              <input
                type="text"
                class="form-control"
                v-bind:class="{ 'has-error': hasError.label }"
                v-model="data.label"
                placeholder="Label"
                id="payment-method"
              />
            </div>
            <div class="form-group">
              <label>Payment Type</label>
              <select v-model="data.type_id" class="form-control">
                <option value="1">Cash</option>
                <option value="2">Credit</option>
              </select>
            </div>
          </c-form>
        </c-card-body>
        <c-card-footer>
          <sur-button
            :object="data"
            @onSave="save"
            @onUpdate="update"
            @onReset="reset"
          />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>

<script>
import { HTTPAUTH } from "../../lib/httplib";
import SURButton from "../../components/SURButton";
import Loader from "../../components/Loader.vue";

export default {
  name: "Add",
  components: {
    "sur-button": SURButton,
    Loader,
  },
  data() {
    return {
      loading: true,
      data: {},
      hasError: {},
    };
  },
  created() {
    const query = this.$route.query;
    if (query.id) {
      this.get(query.id);
    } else {
      this.loading = false;
    }
  },
  methods: {
    get(id) {
      this.loading = true;
      HTTPAUTH.get("/api/v1/payment-method/" + id)
        .then((res) => {
          this.data = res.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    save() {
      this.loading = true;
      HTTPAUTH.post("/api/v1/payment-method", this.data)
        .then(() => {
          this.$toasted.success("Berhasil disimpan").goAway(1000);
          this.reset();
          this.loading = false;
        })
        .catch((eres) => {
          this.$toasted.error(eres.response.data.message).goAway(3000);
          this.hasError = eres.response.data.error;
          this.loading = false;
        });
    },
    update() {
      this.loading = true;
      HTTPAUTH.put("/api/v1/payment-method/" + this.data.id, this.data)
        .then(() => {
          this.$toasted.success("Berhasil disimpan").goAway(1000);
          this.reset();
          this.loading = false;
        })
        .catch((eres) => {
          this.$toasted.error(eres.response.data.message).goAway(3000);
          this.hasError = eres.response.data.error;
          this.loading = false;
        });
    },
    reset() {
      this.data = {};
      this.$router.push({ query: {} });
    },
  },
};
</script>

<style scoped>
</style>
